<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="p-2 ml-3">
      <h3 class="card-title">THEME TYPOGRAPHY</h3>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3 col-sm-4 card-title">Main Body Background</div>
            <div class="col-md-1 col-sm-1 d-none d-sm-block">:</div>
            <div class="col-md-3 card-text">
              <div class="input-group" title="Using format option">
                <button class="btn btn-primary" data-bs-target="#exampleModal" data-bs-toggle="modal"
                        type="button" @click="showModal=true">
                  Add Images
                </button>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button v-if="main_body_bg_img_id" aria-label="Close" class="btn btn-danger mb-1 mt-3"
                          style="padding: 5px;border:1px solid maroon"
                          type="button" @click="removeMainBodyBgImg">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </div>
              <figure v-if="main_body_bg_img_id" class="figure"
                      style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
                <div v-if="main_body_bg_img_path">
                  <img :src="main_body_bg_img_path" alt="media" class="img-thumbnail"
                       style="display:flex;justify-content: center;align-items: center; width:120px; height: 120px; background-color: rgb(244, 245, 245);border-radius: 6px;">
                </div>
              </figure>

            </div>
          </div>
        </div>

        <div class="col-md-12 mt-2">
          <div class="row">
            <div class="col-md-3 col-sm-4 card-title">Body Layout Background</div>
            <div class="col-md-1 col-sm-1 d-none d-sm-block">:</div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="body_layout_bg_color" class="form-control input-lg" type="color"/>
              </div>
            </div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="body_layout_bg_color" class="form-control input-lg" type="text"/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="row">
            <div class="col-md-3 col-sm-4 card-title">Body Layout Size</div>
            <div class="col-md-1 col-sm-1 d-none d-sm-block">:</div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="body_layout_size" class="form-control input-lg" type="number"/>
              </div>
            </div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="body_layout_size" class="form-range form-control input-group" max="1000" min="0"
                       step="1"
                       type="range"/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="row">
            <div class="col-md-3 col-sm-4 card-title">Header Background</div>
            <div class="col-md-1 col-sm-1 d-none d-sm-block">:</div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="header_bg_color" class="form-control input-lg" type="color"/>
              </div>
            </div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="header_bg_color" class="form-control input-lg" type="text"/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="row">
            <div class="col-md-3 col-sm-4 card-title">Footer Background Color</div>
            <div class="col-md-1 col-sm-1 d-none d-sm-block">:</div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="footer_bg_color" class="form-control input-lg" type="color"/>
              </div>
            </div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="footer_bg_color" class="form-control input-lg" type="text"/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="row">
            <div class="col-md-3 col-sm-4 card-title">Menu Background Color</div>
            <div class="col-md-1 col-sm-1 d-none d-sm-block">:</div>
            <div class="col-lg-1 col-sm-3 col-md-2 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="menu_bg_color" class="form-control input-lg" type="color"/>
              </div>
            </div>
            <div class="col-lg-1 col-md-2 1 col-sm-3 card-text">
              <div class="input-group" title="Using format option">
                <input v-model="menu_bg_color" class="form-control input-lg" type="text"/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 my-2">
          <div class="row">
            <div class="col-md-3 col-sm-4 card-title">Font Family</div>
            <div class="col-md-1 col-sm-1 d-none d-sm-block">:</div>
            <div class="col-md-2 col-sm-6 card-text">
              <div class="input-group" title="Using format option">
                <select v-model="theme_font_family" aria-label="Default select example" class="form-select">
                  <option :value=null disabled>---Select Font---</option>
                  <option v-for="font in theme_font_family_list" :key="font.id" :value="font.id">
                    {{ font.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="row mt-4 mb-4">
          <div class="col-md-6">
            <h4><b>Theme Header</b></h4>
            <h5>Typography option with each property can be called individually.</h5>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Font Family <span class="text-danger">*</span></label>
                  <select v-model="theme_header_font" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Font---</option>
                    <option v-for="font in theme_font_family_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Backup Font Family <span class="text-danger">*</span></label>
                  <select v-model="theme_header_bk_font" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Backup Font---</option>
                    <option v-for="font in theme_bk_font_family_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Weight & Style <span class="text-danger">*</span></label>
                  <select v-model="theme_header_font_weight_style" aria-label="Default select example"
                          class="form-select">
                    <option :value=null disabled>---Select Font Weight & Style---</option>
                    <option v-for="font in theme_font_weight_style_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Subsets <span class="text-danger">*</span></label>
                  <select v-model="theme_header_font_subset" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Font Subsets---</option>
                    <option v-for="font in theme_font_subset_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Text Align <span class="text-danger">*</span></label>
                  <select v-model="theme_header_text_align" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Text Align---</option>
                    <option v-for="font in theme_text_align_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Size <span class="text-danger">*</span></label>
                  <input v-model="theme_header_font_size" class="form-control" placeholder="Font Size in px"
                         type="number"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Line Height <span class="text-danger">*</span></label>
                  <input v-model="theme_header_line_height" class="form-control" placeholder="Line Height in px"
                         type="number"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Color <span class="text-danger">*</span></label>
                  <input v-model="theme_header_font_color" class="form-control input-lg" type="color"/>
                </div>
              </div>
              <div class="mb-6">
                <p :style="{
      fontFamily: theme_header_font,
      fontWeight: theme_header_font_weight_style,
      fontSize: `${theme_header_font_size}px`,
      textAlign: theme_header_text_align,
      lineHeight: `${theme_header_line_height}px`,
      color: theme_header_font_color,
      textShadow: '5px 3px 8px rgba(0, 0, 0, 0.5)', // Adjust text shadow as needed
    }" class="clear opt-typography-body-shadow_previewer typography-preview" data-preview-size="0">
                  1 2 3 4 5 6 7 8 9 0 A B C D E F a b c d e f
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="row mt-4 mb-4">
          <div class="col-md-6">
            <h4><b>Theme Footer</b></h4>
            <h5>Typography option with each property can be called individually.</h5>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Font Family <span class="text-danger">*</span></label>
                  <select v-model="theme_footer_font" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Font---</option>
                    <option v-for="font in theme_font_family_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Backup Font Family <span class="text-danger">*</span></label>
                  <select v-model="theme_footer_bk_font" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Backup Font---</option>
                    <option v-for="font in theme_bk_font_family_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Weight & Style <span class="text-danger">*</span></label>
                  <select v-model="theme_footer_font_weight_style" aria-label="Default select example"
                          class="form-select">
                    <option :value=null disabled>---Select Font Weight & Style---</option>
                    <option v-for="font in theme_font_weight_style_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Subsets <span class="text-danger">*</span></label>
                  <select v-model="theme_footer_font_subset" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Font Subsets---</option>
                    <option v-for="font in theme_font_subset_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Text Align <span class="text-danger">*</span></label>
                  <select v-model="theme_footer_text_align" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Text Align---</option>
                    <option v-for="font in theme_text_align_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Size <span class="text-danger">*</span></label>
                  <input v-model="theme_footer_font_size" class="form-control" placeholder="Font Size in px"
                         type="number"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Line Height <span class="text-danger">*</span></label>
                  <input v-model="theme_footer_line_height" class="form-control" placeholder="Line Height in px"
                         type="number"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Color <span class="text-danger">*</span></label>
                  <input v-model="theme_footer_font_color" class="form-control input-lg" type="color"/>
                </div>
              </div>
              <div class="mb-6">
                <p :style="{
      fontFamily: theme_footer_font,
      fontWeight: theme_footer_font_weight_style,
      fontSize: `${theme_footer_font_size}px`,
      textAlign: theme_footer_text_align,
      lineHeight: `${theme_footer_line_height}px`,
      color: theme_footer_font_color,
      textShadow: '5px 3px 8px rgba(0, 0, 0, 0.5)', // Adjust text shadow as needed
    }" class="clear opt-typography-body-shadow_previewer typography-preview" data-preview-size="0">
                  1 2 3 4 5 6 7 8 9 0 A B C D E F a b c d e f
                </p>
              </div>
            </div>
          </div>
        </div>

        <hr/>
        <div class="row mt-4">
          <div class="col-md-6">
            <h4><b>Title Font</b></h4>
            <h5>Specify the body font properties.</h5>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Font Family <span class="text-danger">*</span></label>
                  <select v-model="theme_title_font" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Font---</option>
                    <option v-for="font in theme_font_family_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Backup Font Family <span class="text-danger">*</span></label>
                  <select v-model="theme_title_bk_font" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Backup Font---</option>
                    <option v-for="font in theme_bk_font_family_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Weight & Style <span class="text-danger">*</span></label>
                  <select v-model="theme_title_font_weight_style" aria-label="Default select example"
                          class="form-select">
                    <option :value=null disabled>---Select Font Weight & Style---</option>
                    <option v-for="font in theme_font_weight_style_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Subsets <span class="text-danger">*</span></label>
                  <select v-model="theme_title_font_subset" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Font Subsets---</option>
                    <option v-for="font in theme_font_subset_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Margin Top <span class="text-danger">*</span></label>
                  <input v-model="theme_title_margin_top" class="form-control" placeholder="Margin Top in px"
                         type="number"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Margin Bottom <span class="text-danger">*</span></label>
                  <input v-model="theme_title_margin_bottom" class="form-control" placeholder="Margin Bottom in px"
                         type="number"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Shadow Color <span class="text-danger">*</span></label>
                  <input v-model="theme_title_shadow_color" class="form-control input-lg" type="color"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Text Align <span class="text-danger">*</span></label>
                  <select v-model="theme_title_text_align" aria-label="Default select example" class="form-select">
                    <option :value=null disabled>---Select Text Align---</option>
                    <option v-for="font in theme_text_align_list" :key="font.id" :value="font.id">
                      {{ font.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Size <span class="text-danger">*</span></label>
                  <input v-model="theme_title_font_size" class="form-control" placeholder="Font Size in px"
                         type="number"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Line Height <span class="text-danger">*</span></label>
                  <input v-model="theme_title_line_height" class="form-control" placeholder="Line Height in px"
                         type="number"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Font Color <span class="text-danger">*</span></label>
                  <input v-model="theme_title_font_color" class="form-control input-lg" type="color"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Horizontal: {{ theme_title_shadow_horizontal }}px
                    <span class="text-danger">*</span></label>
                  <input v-model="theme_title_shadow_horizontal" class="form-range form-control input-group" max="100"
                         min="0" step="1"
                         type="range"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Vertical: {{ theme_title_shadow_vertical }}px <span
                      class="text-danger">*</span></label>
                  <input v-model="theme_title_shadow_vertical" class="form-range form-control input-group" max="100"
                         min="0" step="1"
                         type="range"/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Blur: {{ theme_title_shadow_blur }}px <span
                      class="text-danger">*</span></label>
                  <input v-model="theme_title_shadow_blur" class="form-range form-control input-group" max="100" min="0"
                         step="1"
                         type="range"/>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <p :style="{
      fontFamily: theme_title_font,
      fontWeight: theme_title_font_weight_style,
      fontSize: `${theme_title_font_size}px`,
      textAlign: theme_title_text_align,
      lineHeight: `${theme_title_line_height}px`,
      color: theme_title_font_color,
      marginTop: `${theme_title_margin_top}px`,
      marginBottom: `${theme_title_margin_bottom}px`,
      textShadow: `${theme_title_shadow_horizontal}px ${theme_title_shadow_vertical}px ${theme_title_shadow_blur}px ${theme_title_shadow_color}`, // Adjust text shadow as needed
    }" class="clear opt-typography-body-shadow_previewer typography-preview" data-preview-size="0">
                1 2 3 4 5 6 7 8 9 0 A B C D E F a b c d e f
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <button class="btn btn-md btn-danger float-end ml-2">
            Cancel
          </button>
          <button class="btn btn-md btn-primary float-end" @click="saveTypography">
            Save
          </button>

        </div>
      </div>
    </div>
    <div v-if="showModal">
      <div id="exampleModal" aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade show"
           style="display: block" tabindex="-1">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 id="exampleModalLabel" class="modal-title"><b>Add Background Image</b></h5>
              <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                      @click="showModal=false"></button>
            </div>
            <div class="modal-body">
              <div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <!--                  <template v-for="(info, index) in all_images" :key="index">
                      <div class="col-2 d-flex flex-column align-items-start justify-content-start">
                        <img :src="info.file_path" alt="media" class="img-thumbnail"
                             style="display:flex;justify-content: center;align-items: center;padding: 8px;margin: 8px; width:120px; height: 120px; background-color: rgb(244, 245, 245);border-radius: 6px;"
                        @click="selectImage(info)">
                      </div>
                    </template>-->

                      <template v-for="(info, index) in all_images" :key="index">
                        <div class="col-2 d-flex flex-column align-items-start justify-content-start">
                          <img :class="{ 'highlighted': info.media_file_id === main_body_bg_img_id }"
                               :src="info.file_path" alt="media"
                               class="img-thumbnail"
                               style="display:flex;justify-content: center;align-items: center;padding: 8px;margin: 8px; width:120px; height: 120px; background-color: rgb(244, 245, 245);border-radius: 6px;"
                               @click="selectImage(info)" @error="handleImageError">
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" data-bs-dismiss="modal" type="button" @click="showModal=false">Save
                Image
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import ThemeTypographyService from "@/services/theme-typography.service";
import MediaService from "@/services/media.service";
import Config from "@/config";

export default {
  name: 'ThemeTypography',
  components: {},

  mounted() {
    this.getThemeProperty();
    this.getTypography();


  },

  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Theme Options',
          to: '/portal-header'
        }, {
          text: 'Theme Typography',
          href: '#'
        }
      ],
      all_images: [],
      selectedMedia: null,
      main_body_bg_img_path: null,
      main_body_bg_img_id: null,
      showModal: false,
      TypographyReq:
          {
            typography_id: 0,
            main_body_bg_img_id: 0,
            body_layout_bg_color: "null",
            body_layout_size: 0,
            header_bg_color: null,
            footer_bg_color: null,
            menu_bg_color: null,
            theme_header: {
              description: null,
              font_family_id: null,
              backup_font_family_id: null,
              font_weight_style_id: null,
              font_subsets_id: null,
              text_align_id: null,
              font_size: null,
              line_height: null,
              font_color: "#000000",
              margin_top: null,
              margin_bottom: null,
              shadow_color: null,
              sc_horizontal: null,
              sc_vertical: null,
              sc_blur: null,
              typo_theme_type: "header",
            },
            theme_footer: {
              description: null,
              font_family_id: null,
              backup_font_family_id: null,
              font_weight_style_id: null,
              font_subsets_id: null,
              text_align_id: null,
              font_size: null,
              line_height: null,
              font_color: "#000000",
              margin_top: null,
              margin_bottom: null,
              shadow_color: null,
              sc_horizontal: null,
              sc_vertical: null,
              sc_blur: null,
              typo_theme_type: "footer",

            },
            title_font: {
              description: null,
              font_family_id: null,
              backup_font_family_id: null,
              font_weight_style_id: null,
              font_subsets_id: null,
              text_align_id: null,
              font_size: null,
              line_height: null,
              font_color: "#000000",
              margin_top: null,
              margin_bottom: null,
              shadow_color: null,
              sc_horizontal: null,
              sc_vertical: null,
              sc_blur: null,
              typo_theme_type: "title_font",
            }
          },


      theme_font_family_list: [],
      theme_bk_font_family_list: [],
      theme_font_subset_list: [],
      theme_font_weight_style_list: [],
      theme_text_align_list: [],

      theme_header_font: null,
      theme_header_bk_font: null,
      theme_header_font_weight_style: null,
      theme_header_font_subset: null,
      theme_header_text_align: null,
      theme_header_font_size: null,
      theme_header_line_height: null,
      theme_header_font_color: null,

      theme_footer_font: null,
      theme_footer_bk_font: null,
      theme_footer_font_weight_style: null,
      theme_footer_font_subset: null,
      theme_footer_text_align: null,
      theme_footer_font_size: null,
      theme_footer_line_height: null,
      theme_footer_font_color: null,

      theme_title_font: null,
      theme_title_bk_font: null,
      theme_font_family: null,
      theme_title_font_weight_style: null,
      theme_title_font_subset: null,
      theme_title_text_align: null,
      theme_title_font_size: null,
      theme_title_line_height: null,
      theme_title_margin_top: null,
      theme_title_margin_bottom: null,
      theme_title_font_color: null,
      theme_title_shadow_color: null,
      theme_title_shadow_horizontal: null,
      theme_title_shadow_vertical: null,
      theme_title_shadow_blur: null,


      body_layout_size: 1000,
      body_layout_bg_color: "#ffffff",
      header_bg_color: "#ffffff",
      footer_bg_color: "#ffffff",
      menu_bg_color: "#ffffff",
      showModalText: false,
      showModalPlanning: false,
      showModalLogo: false,
      showModalPartners: false,

      isEditEnabledText: true,
      isEditEnabledBanglaText: true,
      isEditEnabledPlanning: true,
      imageList: [],
      logo_file_path: null,
      logo_media_file_id: null,
      footerData: {
        footer_theme_id: 1,
        footer_logo_id: "",
        text: "",
        text_en: "",
        planning: "",
        planning_en: "",
        address: "",
        address_en: "",
        contact: "",
        contact_en: "",
        copyright_text: "",
        copyright_text_en: "",
        facebook_link: "",
        twitter_link: "",
        instagram_link: "",
        youtube_link: "",
        partner_image_id_list: [],
      },
      imageBodyList: [],
    }
  },
  watch: {},
  methods: {
    selectImage(info) {
      this.main_body_bg_img_id = info.media_file_id;
      this.main_body_bg_img_path = info.file_path;
      this.all_images.forEach(element => {
        element.selected = element.media_file_id === info.media_file_id;
      });
    },
    handleImageError(event) {
      event.target.src = "https://demofree.sirv.com/nope-not-here.jpg";
    },
    async fetchMedia() {
      try {
        const response = await MediaService.getAllMedia();
        this.all_images = response.data;
        this.all_images.forEach(element => {
          element.file_path = Config.apiFileBasePath + element.file_path;
          if (element.media_file_id === this.main_body_bg_img_id) {
            this.main_body_bg_img_path = element.file_path;
            element.selected = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Footer',
        text: message,
      });
    },
    async getThemeProperty() {
      const response = await ThemeTypographyService.getThemeProperty();
      if (response.data) {
        this.theme_font_family_list = response.data.fontFamilies;
        this.theme_bk_font_family_list = response.data.bkFontFamilies;
        this.theme_font_subset_list = response.data.fontSubsets;
        this.theme_font_weight_style_list = response.data.fontWeightStyles;
        this.theme_text_align_list = response.data.textAligns;
      }
    },
    async saveTypography() {
      this.TypographyReq.typography_id = 1;
      this.TypographyReq.body_layout_bg_color = this.body_layout_bg_color;
      this.TypographyReq.main_body_bg_img_id = this.main_body_bg_img_id;
      this.TypographyReq.body_layout_size = this.body_layout_size;
      this.TypographyReq.header_bg_color = this.header_bg_color;
      this.TypographyReq.footer_bg_color = this.footer_bg_color;
      this.TypographyReq.menu_bg_color = this.menu_bg_color;
      this.TypographyReq.theme_header.font_family_id = this.theme_header_font;
      this.TypographyReq.font_family_id = this.theme_font_family;
      this.TypographyReq.theme_header.backup_font_family_id = this.theme_header_bk_font;
      this.TypographyReq.theme_header.font_weight_style_id = this.theme_header_font_weight_style;
      this.TypographyReq.theme_header.font_subsets_id = this.theme_header_font_subset;
      this.TypographyReq.theme_header.text_align_id = this.theme_header_text_align;
      this.TypographyReq.theme_header.font_size = this.theme_header_font_size;
      this.TypographyReq.theme_header.line_height = this.theme_header_line_height;
      this.TypographyReq.theme_header.font_color = this.theme_header_font_color;
      this.TypographyReq.theme_footer.font_family_id = this.theme_footer_font;
      this.TypographyReq.theme_footer.backup_font_family_id = this.theme_footer_bk_font;
      this.TypographyReq.theme_footer.font_weight_style_id = this.theme_footer_font_weight_style;
      this.TypographyReq.theme_footer.font_subsets_id = this.theme_footer_font_subset;
      this.TypographyReq.theme_footer.text_align_id = this.theme_footer_text_align;
      this.TypographyReq.theme_footer.font_size = this.theme_footer_font_size;
      this.TypographyReq.theme_footer.line_height = this.theme_footer_line_height;
      this.TypographyReq.theme_footer.font_color = this.theme_footer_font_color;
      this.TypographyReq.title_font.font_family_id = this.theme_title_font;
      this.TypographyReq.title_font.backup_font_family_id = this.theme_title_bk_font;
      this.TypographyReq.title_font.font_weight_style_id = this.theme_title_font_weight_style;
      this.TypographyReq.title_font.font_subsets_id = this.theme_title_font_subset;
      this.TypographyReq.title_font.text_align_id = this.theme_title_text_align;
      this.TypographyReq.title_font.font_size = this.theme_title_font_size;
      this.TypographyReq.title_font.line_height = this.theme_title_line_height;
      this.TypographyReq.title_font.font_color = this.theme_title_font_color;
      this.TypographyReq.title_font.margin_top = this.theme_title_margin_top;
      this.TypographyReq.title_font.margin_bottom = this.theme_title_margin_bottom;
      this.TypographyReq.title_font.shadow_color = this.theme_title_shadow_color;
      this.TypographyReq.title_font.sc_horizontal = this.theme_title_shadow_horizontal;
      this.TypographyReq.title_font.sc_vertical = this.theme_title_shadow_vertical;
      this.TypographyReq.title_font.sc_blur = this.theme_title_shadow_blur;

      //use async await
      const response = await ThemeTypographyService.saveTypography(this.TypographyReq);
      if (response.data) {
        this.showNotification('success', response.data.message);
      } else {
        this.showNotification('error', response.data.message);
      }
    },
    removeMainBodyBgImg() {
      this.main_body_bg_img_id = null;
      this.main_body_bg_img_path = null;
    },

    async getTypography() {

      const response = await ThemeTypographyService.getTypography();
      if (response.data) {
        this.TypographyReq.main_body_bg_img_id = response.data.main_body_bg_img_id;
        this.main_body_bg_img_id = response.data.main_body_bg_img_id;
        this.body_layout_bg_color = response.data.body_layout_bg_color;
        this.body_layout_size = response.data.body_layout_size;
        this.header_bg_color = response.data.header_bg_color;
        this.footer_bg_color = response.data.footer_bg_color;
        this.menu_bg_color = response.data.menu_bg_color;
        this.theme_header_font = response.data.theme_header.font_family_id;
        this.theme_header_bk_font = response.data.theme_header.backup_font_family_id;
        this.theme_font_family = response.data.font_family_id;
        this.theme_header_font_weight_style = response.data.theme_header.font_weight_style_id;
        this.theme_header_font_subset = response.data.theme_header.font_subsets_id;
        this.theme_header_text_align = response.data.theme_header.text_align_id;
        this.theme_header_font_size = response.data.theme_header.font_size;
        this.theme_header_line_height = response.data.theme_header.line_height;
        this.theme_header_font_color = response.data.theme_header.font_color;
        this.theme_footer_font = response.data.theme_footer.font_family_id;
        this.theme_footer_bk_font = response.data.theme_footer.backup_font_family_id;
        this.theme_footer_font_weight_style = response.data.theme_footer.font_weight_style_id;
        this.theme_footer_font_subset = response.data.theme_footer.font_subsets_id;
        this.theme_footer_text_align = response.data.theme_footer.text_align_id;
        this.theme_footer_font_size = response.data.theme_footer.font_size;
        this.theme_footer_line_height = response.data.theme_footer.line_height;
        this.theme_footer_font_color = response.data.theme_footer.font_color;
        this.theme_title_font = response.data.title_font.font_family_id;
        this.theme_title_bk_font = response.data.title_font.backup_font_family_id;
        this.theme_title_font_weight_style = response.data.title_font.font_weight_style_id;
        this.theme_title_font_subset = response.data.title_font.font_subsets_id;
        this.theme_title_text_align = response.data.title_font.text_align_id;
        this.theme_title_font_size = response.data.title_font.font_size;
        this.theme_title_line_height = response.data.title_font.line_height;
        this.theme_title_margin_top = response.data.title_font.margin_top;
        this.theme_title_margin_bottom = response.data.title_font.margin_bottom;
        this.theme_title_font_color = response.data.title_font.font_color;
        this.theme_title_shadow_color = response.data.title_font.shadow_color;
        this.theme_title_shadow_horizontal = response.data.title_font.sc_horizontal;
        this.theme_title_shadow_vertical = response.data.title_font.sc_vertical;
        this.theme_title_shadow_blur = response.data.title_font.sc_blur;
        await this.fetchMedia();
      } else {
        this.showNotification('error', response.data.message);
      }
    },
  },
}

</script>

<style scoped>
.highlighted {
  border: 3px solid #17680BFF;
}
</style>
